import React from 'react'
import CommonCard from '../../../global/card'
import { useLocation } from 'react-router-dom'
import { useGenericQuery } from '../../../../queries/use-generic-query';
import { QUERY_KEYS } from '../../../../lib/query-constants';
import { formatDateTime } from '../../../../utils/functions';
import CommonTable from '../../../global/table';
import CommonSkeletonLoader from '../../../global/loading';

const EnhancedCouponHistory = () => {
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const couponId = queryParams.get('id');

    const { data, isLoading } = useGenericQuery({
        queryKey: QUERY_KEYS.couponUsageHistory.item(couponId),
        queryParams: { couponId },
        endpoint: "coupon/usage-history",
        onError: () => { },
        onSuccess: () => { },
        enabled: !!couponId
    })


    const historyData = Array.isArray(data)
        ? data.map((item) => ({ ...item, id: item._id }))
        : [];

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            isAvatar: true,
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
        },
        {
            title: "Usage at",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (_, record) => record.createdAt ? formatDateTime(record.createdAt) : "-",
        },
    ];


    return (
        <CommonCard
            isLoading={{
                show: isLoading,
                loaderCmp: <CommonSkeletonLoader type="table" rows={10} tableLength={10} />
            }}
        >
            <CommonTable
                columns={columns}
                data={historyData}
                showActions={false}
            />
        </CommonCard>
    )
}

export default EnhancedCouponHistory